module.exports = __webpack_public_path__ + "img/ml3051.da2b8e82.png";